export enum TurmaStatusForInput {
  InProgress = 'Em andamento',
  Finished = 'Finalizado',
}
